import React from 'react';
import { jumpTo } from '@/navigate'
import Tips from "../../components/tips";
import BgAudio from "./bgAudio";
import './index.scss';

class App extends React.Component {
    constructor(props) {
        super(props)
        this.state = {

        }
    }

    componentDidMount() {
    }
    render() {
        return (
            <div className="page page-guide guide_room_2">
                <div className="form_view">
                    <div className="form_tit no_line">危险部位针刺操作<br />注意事项</div>
                    <div className="finish_tips_view">
                        <div className="finish_tips"><i>01</i><span>天枢：注意针刺过深易刺中肠道，导致肠瘘；</span></div>
                        <div className="finish_tips"><i>02</i><span>神阙：该穴禁止针刺；</span></div>
                        <div className="finish_tips"><i>03</i><span>期门：注意针刺角度和深度，若直刺或斜刺过深易刺中肝脏导致疼痛或出血，刺中肺导致气胸。</span></div>
                        <div className="finish_tips"><i>04</i><span>太冲：深刺刺中趾背动脉，易导致血肿，局部疼痛和行走困难。</span></div>
                    </div>
                    <div className="form_btn txt_c">
                        <button onClick={() => { jumpTo("guide10") }}>完成</button>
                    </div>
                </div>
                <audio src={require("../../assets/audio/step_9.mp3")} autoPlay={true}/>
                <Tips init={false} />
                <BgAudio/>
            </div>
        );
    }
}

export default App;
